module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns search buscar-solicitacoes no-print",
    attrs: {
      "id": "relatorioDeSolicitacoesAnual"
    }
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns search buscar-solicitacoes no-print"
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    attrs: {
      "for": "projeto"
    }
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto),
      expression: "projeto"
    }],
    attrs: {
      "id": "projeto",
      "name": "projeto"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.obterDadosDoProjeto]
    }
  }, _vm._l((_vm.projetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.Id
      }
    }, [_vm._v("\n                " + _vm._s(projeto.Nome) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    attrs: {
      "for": "empreendimento"
    }
  }, [_vm._v("Empreendimento")]), _vm._v(" "), _c('selectSearch', {
    attrs: {
      "id": "empreendimento",
      "options": _vm.empreendimentos,
      "placeholder": "Selecione",
      "selectLabel": "",
      "deselect-label": "",
      "label": "Nome",
      "searchable": true,
      "allow-empty": true,
      "show-labels": false,
      "showNoResults": false,
      "disabled": _vm.deveDesabilitarFiltro
    },
    model: {
      value: (_vm.empreendimento),
      callback: function($$v) {
        _vm.empreendimento = $$v
      },
      expression: "empreendimento"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('vue-multi-select', {
    ref: "multiSelect",
    attrs: {
      "id": "status",
      "btnClass": _vm.btnClass,
      "btnLabel": _vm.btnLabel,
      "popoverClass": _vm.popoverClass,
      "options": _vm.options,
      "selectOptions": _vm.situacoes,
      "disabled": _vm.deveDesabilitarFiltro,
      "emptyTabText": "Carregando..."
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(ref) {
        var option = ref.option;

        return [_c('div', {
          staticClass: "opcao-de-situacao"
        }, [_c('input', {
          staticClass: "opcao-de-situacao__checkbox",
          attrs: {
            "type": "checkbox",
            "tabindex": "-1"
          },
          domProps: {
            "checked": option.selected
          }
        }), _vm._v(" "), _c('span', {
          class: ['tags']
        }, [_vm._v(_vm._s(option.name))])])]
      }
    }]),
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    attrs: {
      "for": "periodo"
    }
  }, [_vm._v("Período")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "range-separator": '  até  ',
      "format": 'DD/MM/YYYY',
      "type": "date",
      "range": "",
      "placeholder": "Selecione um período"
    },
    model: {
      value: (_vm.periodo),
      callback: function($$v) {
        _vm.periodo = $$v
      },
      expression: "periodo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    attrs: {
      "for": "municipio"
    }
  }, [_vm._v("Município")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cidade),
      expression: "cidade"
    }],
    attrs: {
      "id": "cidade",
      "name": "cidade",
      "disabled": _vm.deveDesabilitarFiltro
    },
    on: {
      "blur": _vm.obterEmpreendimentos,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cidade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cidades), function(cidade) {
    return _c('option', {
      domProps: {
        "value": cidade.Id
      }
    }, [_vm._v("\n                " + _vm._s(cidade.Nome) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    attrs: {
      "for": "tipoDeRelatorio"
    }
  }, [_vm._v("Tipo de relatório")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "formulario__radio-container",
    attrs: {
      "for": "visualizar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "name": "radio",
      "type": "radio",
      "value": "visualizar",
      "disabled": _vm.deveEsconderTipoRelatorio
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "visualizar")
    },
    on: {
      "change": function($event) {
        _vm.selectedOption = "visualizar"
      }
    }
  }), _vm._v("Visualizar lista para publicação\n              ")])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "formulario__radio-container",
    attrs: {
      "for": "visualizar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "name": "radio",
      "type": "radio",
      "value": "excel",
      "disabled": _vm.deveEsconderTipoRelatorio
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "excel")
    },
    on: {
      "change": function($event) {
        _vm.selectedOption = "excel"
      }
    }
  }), _vm._v("Baixar lista para conferência\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_1"
  }, [_c('button', {
    staticClass: "botao botao_grande botao_cor-terciaria",
    attrs: {
      "type": "submit",
      "disabled": !_vm.selectedOption
    },
    on: {
      "click": _vm.handleBotaoAcao
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedOption === "excel" ? "Baixar" : "Filtrar") + "\n            ")])])])])])], 1), _vm._v(" "), (_vm.selectedOption === 'visualizar' && _vm.mostrarRelatorio) ? _c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__linha grade__linha_alinhar-horizontal-esquerda u-padding-pequena"
  }, [(this.filtroSelecionado.projeto) ? _c('p', {
    staticClass: "texto texto_mini"
  }, [_vm._v("\n          Projeto:\n          "), _c('span', {
    staticClass: "texto_cor-terciaria"
  }, [_vm._v(_vm._s(this.filtroSelecionado.projeto))]), _vm._v("\n          /\n        ")]) : _vm._e(), _vm._v(" "), (this.filtroSelecionado.cidade) ? _c('p', {
    staticClass: "texto texto_mini"
  }, [_vm._v("\n          Cidade:\n          "), _c('span', {
    staticClass: "texto_cor-terciaria"
  }, [_vm._v(_vm._s(this.filtroSelecionado.cidade) + " /")])]) : _vm._e(), _vm._v(" "), (this.filtroSelecionado.empreendimento) ? _c('p', {
    staticClass: "texto texto__pequeno"
  }, [_vm._v("\n          Empreendimento:\n          "), _c('span', {
    staticClass: "texto_cor-terciaria"
  }, [_vm._v("\n            " + _vm._s(this.filtroSelecionado.empreendimento))]), _vm._v("\n          /\n        ")]) : _vm._e(), _vm._v(" "), (this.filtroSelecionado.status) ? _c('p', {
    staticClass: "texto texto_mini"
  }, [_vm._v("\n          Situação:\n          "), _c('span', {
    staticClass: "texto_cor-terciaria"
  }, [_vm._v(" " + _vm._s(this.filtroSelecionado.status))]), _vm._v("\n          /\n        ")]) : _vm._e(), _vm._v(" "), (this.filtroSelecionado.data) ? _c('p', {
    staticClass: "texto texto_mini"
  }, [_vm._v("\n          Data:\n          "), _c('span', {
    staticClass: "texto_cor-terciaria"
  }, [_vm._v(" " + _vm._s(this.filtroSelecionado.data))]), _vm._v("\n          /\n        ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRelatorio) ? _c('p', {
    staticClass: "texto texto_mini"
  }, [_vm._v("\n          Tipo de relatório:\n          "), _c('span', {
    staticClass: "texto_cor-terciaria"
  }, [_vm._v(" Visualizar lista para publicação ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_10"
  }, [_c('h2', [_vm._v(_vm._s(_vm.nomeDoRelatorio))])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('button', {
    staticClass: "botao botao_medio botao_contorno botao_largura-total botao_cor-terciaria",
    attrs: {
      "type": "submit",
      "disabled": !_vm.liberarBotao || (_vm.liberarBotao && _vm.informacoesParaRelatorio.length === 0)
    },
    on: {
      "click": _vm.gerarPdf
    }
  }, [_vm._v("\n          Gerar PDF\n        ")])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha informacoes-resultado-filtro no-print grade__linha_distribuir-horizontal-entre-elementos"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_9"
  }, [(_vm.informacoesParaRelatorio.length === 0) ? _c('h4', {
    staticClass: "titulo titulo_pequeno"
  }, [_vm._v("\n          Nenhuma solicitação encontrada\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.informacoesParaRelatorio.length > 0) ? _c('table', {
    staticClass: "tabela tabela_listrada tabela_com-largura-total"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ordem de Solicitação")]), _vm._v(" "), (_vm.deveExibirFaixaDeRenda) ? _c('th', [_vm._v("Faixa de Renda")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Município da solicitação")]), _vm._v(" "), _c('th', [_vm._v("Solicitado")]), _vm._v(" "), _c('th', [_vm._v("Reservado")]), _vm._v(" "), _c('th', [_vm._v("Subsídio")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.informacoesParaRelatorio), function(informacao) {
    return (_vm.informacoesParaRelatorio.length > 0) ? _c('tr', {
      attrs: {
        "id": informacao.Id
      }
    }, [_c('td', [_c('p', [_vm._v(_vm._s(informacao.Ordem))])]), _vm._v(" "), (_vm.deveExibirFaixaDeRenda) ? _c('td', [_vm._v("\n            " + _vm._s(informacao.FaixaDeRenda) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', _vm._l((informacao.Proponentes), function(proponente) {
      return _c('div', [_c('p', [_vm._v(_vm._s(proponente.Cpf))])])
    }), 0), _vm._v(" "), _c('td', _vm._l((informacao.Proponentes), function(proponente) {
      return _c('div', [_c('p', [_vm._v(_vm._s(proponente.Nome))])])
    }), 0), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(informacao.NomeDaCidade) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(informacao.DataDaSolicitacao ? informacao.DataDaSolicitacao : "---") + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(informacao.DataDaReserva ? informacao.DataDaReserva : "---") + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.exibirComoMoeda(informacao.ValorDoSubsidio)) + "\n          ")])]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), _c('paginacao', {
    attrs: {
      "paginaAtual": _vm.paginaAtual,
      "totalDePaginas": _vm.totalDePaginas,
      "totalDeRegistros": _vm.totalDeRegistros
    },
    on: {
      "paginar": _vm.mostrarRelatorioNaTela
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b66d225"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/relatorios/GerarRelatorioDeSolicitacao.vue
// module id = 1127
// module chunks = 1